var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uCDE8\\uD569\\uD55C-\\uCD5C\\uC885-\\uD398\\uC774\\uC9C0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FANFT_web_MintView",
    transform: "translate(-848.000000, -360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(848.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 20 18 20 18 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16666667,13.3333333 C9.16666667,14.2541667 8.42083333,15 7.5,15 C6.57916667,15 5.83333333,14.2541667 5.83333333,13.3333333 C5.83333333,12.4125 6.57916667,12.5833333 7.5,12.5833333 C8.42083333,12.5833333 9.16666667,12.4125 9.16666667,13.3333333 Z",
    id: "Stroke-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,12.5 L1.66666667,12.5 L1.66666667,5.83333333 C1.66666667,2.61166667 4.27833333,0 7.5,0 L7.5,0 C10.7216667,0 13.3333333,2.61166667 13.3333333,5.83333333 L13.3333333,12.5 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,12.5 L1.66666667,12.5 L1.66666667,5.83333333 C1.66666667,2.61166667 4.27833333,0 7.5,0 L7.5,0 C10.7216667,0 13.3333333,2.61166667 13.3333333,5.83333333 L13.3333333,12.5 Z",
    id: "Stroke-7",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 12.083333)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.5,
    x2: 15,
    y2: 0.5,
    id: "Fill-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.5,
    x2: 15,
    y2: 0.5,
    id: "Stroke-11",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBell);
export default __webpack_public_path__ + "static/media/ic_bell.4d3efd8855a033fb734637fab49950d0.svg";
export { ForwardRef as ReactComponent };